import React, { useState } from 'react';

// components
import Header from '../../components/Header/Header';
import Form from '../../components/Form/Form';

// icons
import icon from '../../brand/generated/sidebar/profile.svg';
import { useSelector } from 'react-redux';
import { dealerCentresText, roleText } from './dealerCentres';

const Profile = () => {
  const [profile, setProfile] = useState([]);
  const user = useSelector((state) => state.user);
  React.useEffect(() => {
    setProfile([
      { type: 'input', label: 'Фамилия', value: user.surname, disabled: true },
      { type: 'input', label: 'Имя', value: user.name, disabled: true },
      { type: 'input', label: 'Отчество', value: user.middlename, disabled: true },
      { type: 'input', label: 'Регион', value: user.city?.title, disabled: true },
      { type: 'input', label: 'Роль', value: roleText(user), disabled: true },
      { type: 'input', label: 'Автосалон', value: dealerCentresText(user), disabled: true },
    ]);
  }, [user]);
  return (
    <>
      <Header title="Мой профиль" icon={icon} />
      <div style={{ marginTop: '80px', display: 'flex', columnGap: '20px', alignItems: 'center' }}>
        <div style={{ flex: 1 }}>
          <Form
            inputs={profile}
            title={'Данные профиля'}
            grid={{ display: 'grid', gap: '20px', gridTemplateColumns: 'repeat(3, auto)' }}
            border
          />
        </div>
      </div>
    </>
  );
};

export default Profile;
